

















































import { Component, Vue, Watch } from 'vue-property-decorator';
import { User } from 'oidc-client';
import { WorkordersApi, Workorder, CommentKind } from 'performo-api';
import RequesterDetail from '@/components/orders/requester/detail.vue';
import WorkerDetail from '@/components/orders/worker/detail.vue';
import { mapGetters } from 'vuex';

@Component({
  components: {
    RequesterDetail,
    WorkerDetail
  },
  computed: mapGetters({
    api: 'ordersApi'
  })
})
export default class OrderDetail extends Vue {
  private api!: WorkordersApi;

  private order!: Workorder;
  private photo!: Blob;

  private unauthorized = false;

  data() {
    // this lets the undefined order!, photo! refs become reactive
    // https://class-component.vuejs.org/guide/class-component.html#data
    return {
      order: undefined,
      photo: undefined
    };
  }

  // this watch allows us to navigate to other orders from the context of an order
  // the immediate: true makes this behave similar to mounted, so we load it initially
  @Watch('$route.path', { immediate: true })
  private async update() {
    await this.refresh();
  }

  private async refresh(data?: Workorder) {
    if (data) {
      this.order = data;
    } else {
      try {
        this.order = await this.api.getWorkOrder({
          workorderId: this.$route.params.id
        });
      } catch (error) {
        if (error instanceof Response) {
          if (error.status === 403) {
            this.unauthorized = true;
          }
        }
      }
    }
    this.photo = await this.api.getOrderPhotoByIndex({
      workorderId: this.$route.params.id,
      index: 0
    });
  }

  private async addComment(text: string, kind: string) {
    // let text = prompt('Enter your comment:', '');
    if (text && text.length > 0) {
      // public or private note?
      await this.api.addComment({
        workorderCommentCommand: {
          commentText: text,
          workorderId: this.order.workorderId,
          commentTime: new Date(),
          kind: kind === 'public' ? CommentKind.NUMBER_1 : CommentKind.NUMBER_2
        }
      });
      this.order = await this.api.getWorkOrder({
        workorderId: this.$route.params.id
      });
    }
  }

  private async surveySubmittedHandler(survey: {
    message: string;
    rating: string;
  }) {
    await this.api.completeSurvey({
      workorderSurveyCompleteCommand: {
        workorderId: this.order.workorderId,
        surveyText: survey.message,
        surveyRating: parseInt(survey.rating)
      }
    });

    // refresh
    this.order = await this.api.getWorkOrder({
      workorderId: this.$route.params.id
    });
  }

  get user(): User {
    return this.$store.state.user;
  }

  private userHasInterface(interfaceName: string): boolean {
    if (!this.user.profile) {
      return false;
    } // bail out if we can't read the profile object
    if (Array.isArray(this.user.profile.interface)) {
      return this.user.profile.interface.includes(interfaceName);
    }
    return this.user.profile.interface === interfaceName;
  }
}
